import React from 'react';
import { ItemSection, ItemData } from './ItemSection';
const data: ItemData = {
  number: 5,
  title: "Basic Filters Don't Work in Hot, Fast-Moving Showers (Why Your Generic Bunnings Filter Didn't Help)",
  titleImages: [{
    url: 'https://cdn.magicpatterns.com/uploads/w2mCYosGfgq64py6Teiyey/unnamed_(7).jpg',
    alt: 'Comparison diagram showing a cheap carbon filter failing at high temperature with only 60% removal versus an advanced multi-stage filter succeeding with 99% chlorine removal using KDF-55 redox reaction optimized for 42°C water'
  }],
  mechanism: <>
      You might have tried a basic shower filter from Bunnings, Kmart, Amazon or
      a hardware store. These use activated carbon, which relies on absorption,
      a <strong data-id="element-116">slow process</strong> requiring time and low temperature.
      Chlorine, being volatile, <strong data-id="element-117">escapes as gas</strong> before it can be
      absorbed.
    </>,
  avatars: {
    michelle: <>
        This is why <strong data-id="element-118">mechanism matters more than price</strong>. A $20
        filter that doesn't work is worse than an $80 filter that{' '}
        <strong data-id="element-119">does</strong>.
      </>
  },
  bridge: <>
      These filters show 20-40% reduction under lab conditions (slow, cold
      water) but in a realistic actual shower, (hot, fast water) they fail.
    </>,
  image: {
    url: 'https://images.unsplash.com/photo-1581093458791-9d42e3c2fd45?w=800&q=80',
    alt: 'Comparison diagram showing water flow through cheap carbon filter (with escaping chlorine gas) versus multi-stage filter (capturing chlorine), illustrating filter mechanism difference'
  },
  imageOnLeft: true,
  bgColor: 'bg-brand-cream',
  borderBottom: 'border-b-2 border-brand-gold'
};
export function Item6Section() {
  return <ItemSection data={data} data-id="element-120" />;
}